<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <div class="app-screen app-screen--modal-bg" style="padding: 36px 12px 14px;">
    <AppScreensStatusBar :time="t('mock.statusTime')" />

    <!-- Title row with close × -->
    <div style="display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 10px;">
      <div>
        <div style="font-weight: 700; font-size: 13px;">{{ t('mock.vcard.title') }} ·</div>
        <div style="font-size: 9.5px; color: var(--app-text-dim); font-family: ui-monospace, monospace;">{{ t('mock.vcard.code') }}</div>
      </div>
      <div style="color: var(--app-text-dim); font-size: 16px;">×</div>
    </div>

    <!-- Green pill: at the till + timer -->
    <div class="app-card app-card--green" style="display: flex; align-items: center; gap: 8px; padding: 7px 10px; margin-bottom: 7px;">
      <span style="color: var(--app-green);">📷</span>
      <span style="font-size: 10.5px; font-weight: 600; flex: 1;">{{ t('mock.vcard.checkout') }}</span>
      <span style="font-family: ui-monospace, monospace; font-size: 11px; font-weight: 700;">{{ t('mock.vcard.timer') }}</span>
    </div>

    <!-- Red cancel pill -->
    <div class="app-card app-card--red" style="display: flex; align-items: center; justify-content: center; gap: 6px; padding: 6px; margin-bottom: 7px;">
      <span style="color: var(--app-red);">⊘</span>
      <span style="font-size: 10.5px; font-weight: 600; color: var(--app-red);">{{ t('mock.vcard.cancel') }}</span>
    </div>

    <div style="font-size: 9px; color: var(--app-text-dim); line-height: 1.4; margin-bottom: 8px;">
      {{ t('mock.vcard.hint') }}
    </div>

    <!-- Virtual card -->
    <div class="app-vcard">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 6px;">
        <div class="app-vcard__chip">
          <span style="font-weight: 800; letter-spacing: 0.05em;">{{ t('mock.vcard.brand') }}</span>
          <span style="opacity: 0.85;">{{ t('mock.vcard.last4') }}</span>
        </div>
        <div style="display: flex; gap: 6px; align-items: center; font-size: 10.5px;">
          <span style="opacity: 0.7;">⤢</span>
          <span style="font-family: ui-monospace, monospace; font-weight: 700;">{{ t('mock.vcard.left') }}</span>
        </div>
      </div>
      <div style="font-size: 9.5px; opacity: 0.82; margin-bottom: 6px;">{{ t('mock.vcard.limit') }}</div>

      <div class="app-vcard__row">
        <div>
          <div class="app-vcard__row-label">{{ t('mock.vcard.numLbl') }}</div>
          <div class="app-vcard__num">{{ t('mock.vcard.num') }}</div>
        </div>
        <span style="opacity: 0.7;">⎘</span>
      </div>

      <div style="display: flex; gap: 6px; margin-top: 6px;">
        <div class="app-vcard__row" style="flex: 1; margin-top: 0;">
          <div>
            <div class="app-vcard__row-label">{{ t('mock.vcard.expLbl') }}</div>
            <div class="app-vcard__num" style="font-size: 12px;">{{ t('mock.vcard.exp') }}</div>
          </div>
          <span style="opacity: 0.7;">⎘</span>
        </div>
        <div class="app-vcard__row" style="flex: 1; margin-top: 0;">
          <div>
            <div class="app-vcard__row-label">{{ t('mock.vcard.cvcLbl') }}</div>
            <div class="app-vcard__num" style="font-size: 12px;">{{ t('mock.vcard.cvc') }}</div>
          </div>
          <span style="opacity: 0.7;">⎘</span>
        </div>
      </div>

      <div class="app-vcard__row">
        <div>
          <div class="app-vcard__row-label">{{ t('mock.vcard.nameLbl') }}</div>
          <div style="font-weight: 700; font-size: 11px; letter-spacing: 0.04em;">{{ t('mock.vcard.name') }}</div>
        </div>
        <span style="opacity: 0.7;">⎘</span>
      </div>

      <div style="font-size: 8.5px; opacity: 0.85; line-height: 1.4; margin-top: 8px;">
        {{ t('mock.vcard.footer') }}
      </div>
    </div>

    <button class="app-btn app-btn--white" style="margin-top: 10px;">
      <span>●</span><span>{{ t('mock.vcard.paid') }}</span>
    </button>
  </div>
</template>
